import {
  buildWorkspaceQuery,
  workspaceRequest,
} from "./workspaceApiShared";

export async function listManagedWorkspaceBookings(token, salonId = null) {
  const suffix = buildWorkspaceQuery({ salon_id: salonId });
  return workspaceRequest(`/workspaces/managed/bookings${suffix}`, {
    token,
    fallback: "Unable to load workspace bookings.",
  });
}

export async function listWorkspaceBookings(workspaceId, token) {
  return workspaceRequest(`/workspaces/${workspaceId}/bookings`, {
    token,
    fallback: "Unable to load workspace bookings.",
  });
}

export async function createWorkspaceBooking(workspaceId, payload, token = null) {
  return workspaceRequest(`/workspaces/${workspaceId}/bookings`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to create workspace booking.",
  });
}

export async function approveWorkspaceBooking(bookingId, payload, token) {
  return workspaceRequest(`/workspaces/bookings/${bookingId}/approve`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to approve workspace booking.",
  });
}

export async function cancelWorkspaceBooking(bookingId, payload, token) {
  return workspaceRequest(`/workspaces/bookings/${bookingId}/cancel`, {
    method: "POST",
    token,
    body: payload,
    fallback: "Unable to cancel workspace booking.",
  });
}

export async function listWorkspaceBookingEvents(bookingId, token) {
  return workspaceRequest(`/workspaces/bookings/${bookingId}/events`, {
    token,
    fallback: "Unable to load booking events.",
  });
}

export async function getMyWorkspaceBookings(token) {
  return workspaceRequest(`/workspaces/me/bookings`, {
    token,
    fallback: "Unable to load your workspace bookings.",
  });
}
